module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Oud-Brabant.ef6ff66e.jpg";